import { useQuery } from '@tanstack/react-query'

import { ApiUrlPath, X_AUTH_TOKEN, AppMsg, IActivity } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

type TData = {
  data: IActivity[]
}

type TError = {
  msg: AppMsg
}

export default () => {
  const getUserActivity = async () => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const res = await fetch(ApiUrlPath.GetUserActivity, {
      headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
      signal: abortController.signal,
    })

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as TData
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useQuery<TData, TError>([ApiUrlPath.GetUserActivity], getUserActivity, {
    cacheTime: 0,
  })
}
